import store from '@/store'
import getFamilyMembers from '@/views/family/lib/getFamilyMembers'
import { Route } from 'vue-router'
import getNextOrServiceRequestDraftPath from './helpers/getNextOrServiceRequestDraftPath'

export default async (to: Route, { meta }: Route, next: Function) => {
  await getFamilyMembers()

  const familyMembers = store.getters['family/familyMembers']()

  switch (true) {
    case Boolean(!store.getters['auth/isAuthenticated']()):
      next({ path: '/login', query: to.query })
      break

    case Boolean(familyMembers.length > 1):
      next(await getNextOrServiceRequestDraftPath(meta))
      break

    case Boolean(familyMembers.length === 1):
      next(
        await getNextOrServiceRequestDraftPath(meta, {
          path: `/profil#${familyMembers[0].username}`,
        }),
      )
      break

    default:
      next({ name: 'my-caregivers' })
      break
  }
}
